// 搜索相关的类型定义
import type { Template } from '../entities/youyan/template';

// 基础数据接口
export interface IDataBasic {
  id: number;
  create_time: string;
  update_time: string;
}

// 帮助搜索接口
export interface IHelpSearch extends IDataBasic {
  model_type: SearchModelType; // 对象类型：0-帮助中心文档，1-企业案例 2 教程
  model_id: string; // 文档id/案例id
  document_key: string; // 文档key
  document_name: string; // 文档名称
  display_content: {
    text: string; // 展示文本
    highlight_text: string; // 高亮文本
    anchor_point_id: number; // 锚点id
  }; // 文档命中内容或文档描述
  display_title: {
    text: string; // 展示文本
    highlight_text: string; // 高亮文本
    anchor_point_id: number; // 锚点id
  }; // 文档命中标题或文档标题
  update_time: string; // 更新时间
  column_id: number; // 栏目id
  column_title: string; // 栏目标题
  image_url?: string; // 图片路径
  video_url?: string; // 视频路径
  preview_video?: string; // 视频预览
  video_cover_url?: string; // 视频封面
  cover_url?: string; // 封面图片
  audio_url?: string; // 音频路径
  is_new?: boolean; // 是否是新文档
  column_outer_id?: string; // 标识字符
}

// 产品亮点接口
export interface IProductHighlight extends IDataBasic {
  product_highlights: string;
  title: string;
  description: string;
  upload_path_prefix: string;
  click_jump_to: string;
  card_base_image_path: string;
  card_base_image_url: string;
  card_icon_image_path: string;
  card_icon_image_url: string;
  video_cover_path: string;
  video_cover_url: string;
  card_title: string;
  card_subtitle: string;
  video_path: string;
  video_url: string;
  online_status: number;
  rank: number;
  seo_title: string;
  seo_keywords: string;
  seo_description: string;
  online_time: number;
  editor_id: number;
  editor_name: number;
  template_id: number;
  secret_id: number;
  hover_video: string;
  preview_m3u8_url: string;
  show_new_icon: boolean;
}

// 场景数据
export interface ScenariosData {
  display_title: {
    text: string;
    anchor_point_id: number;
  };
  display_content: {
    text: string;
    anchor_point_id: number;
  };
  is_new: boolean;
  cover_url: string;
  preview_video: string;
  video_url: string;
  tag_name: string;
  tag_id: number;
  outer_id: number;
}

// 角色数据
export interface CharacterData {
  name: string;
  config_type: number;
  id: number;
  identity: string;
  secret_id: string;
  image_url: string;
  oss_path: string;
  cover_url: string;
  url: string;
  description: string;
  is_new: string;
  look_name: string;
  tag: string;
}

// 分类搜索数据
export interface ClassSearchData {
  cover_url: string;
  hover_vide: string;
  id: number;
  jump_id: number;
  type: string;
  is_new: boolean;
}

// 全站搜索结果
export interface ISiteSearchResult {
  promotion_center?: {
    data: IHelpSearch[];
    count: number;
    page: number;
    page_size: number;
  };
  product_highlights?: {
    data: IProductHighlight[];
    count: number;
    page: number;
    page_size: number;
  };
  templates?: {
    data: Template[];
    count: number;
    page: number;
    page_size: number;
  };
  character?: {
    data: CharacterData[];
    count: number;
    page: number;
    page_size: number;
  };
  scenarios?: {
    data: ScenariosData[];
    count: number;
    page: number;
    page_size: number;
  };
  enterprise_cases?: {
    data: IHelpSearch[];
    count: number;
    page: number;
    page_size: number;
  };
  guide?: {
    data: ClassSearchData[];
    count: number;
    page: number;
    page_size: number;
  };
  course?: {
    data: IHelpSearch[];
    count: number;
    page: number;
    page_size: number;
  };
}

// 搜索模型类型枚举
export enum SearchModelType {
  HELP_CENTER = 0, // 帮助中心
  ENTERPRISE_CASES = 1, // 企业案例
  TUTORIAL = 2, // 教程
  ACADEMY = 3, // 魔法学院
  PRODUCT_HIGHLIGHTS = 4, // 产品亮点
  TEMPLATES = 5, // 作品
  SCENARIOS = 6, // 应用场景
  CHARACTER = 7, // 3d数字人
  INDEX_DOCUMENT = 8, // 首页文档
}

// 推荐搜索参数
export interface RecommendSearchParams {
  q: string;
  model_type?: SearchModelType;
  group_id?: number;
}

// 推荐搜索结果
export interface RecommendSearchResult {
  id: number;
  question: string;
  highlight_question: string;
  model_type: SearchModelType;
  online_status: number;
  gender?: string; // 性别
  resolution?: string; // 分辨率
  object_type?: number; // 对象类型
  column_id?: number; // 栏目ID
  group_id?: number; // 分组ID
  _score?: number; // 搜索评分
  _object_type_text?: string; // 对象类型文本
  _group_rank?: number; // 分组排名
}

// 全站搜索参数
export interface SiteSearchParams {
  category?: string;
  q: string;
  page: number;
  page_size: number;
}

// 搜索历史参数
export interface SearchHistoryParams {
  search_area: string;
  history_length?: number;
}

// 编辑搜索历史参数
export interface EditSearchHistoryParams {
  search_area?: string;
  search_record?: string;
  is_del?: boolean;
  history_length?: number;
}
